export const PIC_CONFIG = {
	key: 'pic',
	collection: 'initiatives',
	logo: '/assets/img/logo_pic.png',
	favicon: '/assets/img/favicon_pic.png',
	welcome: 'Bienvenido a PIC Málaga.',
	helpModal: {
		title: 'Plataforma de Iniciativas Ciudadanas 🙌',
	  subtitle: '¿QUÉ INICIATIVAS CIUDADANAS HAY EN TU BARRIO?, ¿PARTICIPAS EN ALGUNA?, ¿QUIERES DARLA A CONOCER?',
	  description: [
	  	'El objetivo de este proyecto es mostrar la ciudad de Málaga desde una perspectiva social de movimientos emergentes, iniciativas vecinales y nuevas tendencias urbanas dentro de sus barrios. Dar a conocer esa realidad social  -con poca visibilidad en la ciudad- además de crear una red de colectivos y asociaciones, y establecer posibles sinergias.'
	  ],
	  image: '/assets/img/city.png',
	  type: 'help',
	  id: '',
	  options: ''
	},
	filters: ['Accesibilidad', 'Arte urbano', 'Arquitectura', 'Autogestión', 'Cuidado', 'Culto', 'Cultura', 'Deporte', 'Derechos sociales', 'Diversidad', 'Educación', 'Integración', 'Igualdad', 'Mediación', 'Medio ambiente', 'Movilidad sostenible', 'Participación ciudadana', 'Patrimonio material', 'Patrimonio cultural inmaterial', 'Personas mayores', 'Política social', 'Urbanismo', 'Salud', 'Gentrificación'],
	purpose: [
		{ value: 'Accesibilidad', label: 'Accesibilidad: eliminación de barreras, diseño universal...' },
    { value: 'Arte urbano', label: 'Arte urbano: educación artística, graffiti...' },
    { value: 'Arquitectura', label: 'Arquitectura: patrimonio industrial, bien de interés cultural...' },
    { value: 'Autogestión', label: 'Autogestión: gobernanza urbana, trabajo colaborativo en red...' },
    { value: 'Cuidado', label: 'Cuidado: salud, alimentación, calidad de vida...' },
    { value: 'Culto', label: 'Culto: religión, creencias, rito...' },
    { value: 'Cultura', label: 'Cultura: educación libre, aprendizaje colaborativo...' },
    { value: 'Deporte', label: 'Deporte: actividad física y/o lúdica, gamificación...' },
    { value: 'Derechos sociales', label: 'Derechos sociales: derechos Humanos, igualdad de derechos y deberes...' },
    { value: 'Diversidad', label: 'Diversidad: apoyo a la integración, atención a la diversidad...' },
    { value: 'Educación', label: 'Educación: aprendizaje basado en proyectos, comunidades de aprendizaje, AMPA...' },
    { value: 'Integración', label: 'Integración: interculturalidad, inmersión cultural...' },
    { value: 'Igualdad', label: 'Igualdad: perspectiva de género, feminismo...' },
    { value: 'Mediación', label: 'Mediación: intermediación, facilitación...' },
    { value: 'Medio ambiente', label: 'Medio ambiente: ecología, permacultura, huertos urbanos...' },
    { value: 'Movilidad sostenible', label: 'Movilidad sostenible: transporte público, espacios tranquilos y saludables...' },
    { value: 'Participación ciudadana', label: 'Participación ciudadana: trabajo colaborativo, herramientas para la organización ciudadana, empoderamiento vecinal...' },
    { value: 'Patrimonio material', label: 'Patrimonio material: arqueología, preexistencias, vestigios...' },
    { value: 'Patrimonio cultural inmaterial', label: 'Patrimonio cultural inmaterial:  tradiciones, costumbres, oficios...' },
    { value: 'Personas mayores', label: 'Personas mayores: atención a la tercera edad, envejecimiento activo...' },
    { value: 'Política social', label: 'Política social: banco de tiempo, crowfunding (economía colaborativa), cooperativas vecinales...' },
    { value: 'Urbanismo', label: 'Urbanismo: regeneración urbana, rutas urbanas, estrategias urbanas...' },
    { value: 'Salud', label: 'Salud: bienestar, vida saludable...' },
    { value: 'Gentrificación', label: 'Gentrificación: Turistificación, apartamentos turísticos...' }
	],
	area: [
    { value: 'Espacios culturales', label: 'Espacios culturales: Centro cultural, bibliotecas, museos, universidad...' },
    { value: 'Sedes ciudadanas', label: 'Sedes ciudadanas: Sede de asociaciones, coworking(espacios de trabajo colaborativo), talleres...' },
    { value: 'Espacio público', label: 'Espacio público: Plazas, parques, calles, vacíos urbanos...' },
    { value: 'Espacios virtuales', label: 'Espacios virtuales: Redes sociales, plataformas, blogs...' }
  ],
  relatedInitiatives: true,
  downloadCSV: true,
  searchLabel: 'Buscar por colectivo',
  formNameLabel: 'Nombre del colectivo',
  styles: {
  	navbar: '#Ff8326',
  	navbarUnderline: 'linear-gradient(to top, #d75d00 2px, rgba(0, 174, 199, 0) 2px), linear-gradient(to top, #ffbb88 2px, rgba(210, 210, 210, 0) 1px)',
  	button: '#FF994F',
  	buttonDarker: '#FF8226',
  	buttonUnderline: 'linear-gradient(to top, #d75d00 2px, rgba(0, 174, 199, 0) 2px), linear-gradient(to top, #ffbb88 2px, rgba(210, 210, 210, 0) 1px)',
  	circle: '#d75d00',
  	lineGradient: [
			'interpolate',
			['linear'],
			['line-progress'],
			0, '#d75d00',
			0.1, '#ea6400',
			0.3, '#ff8326',
			0.5, '#ff9b51',
			0.7, '#ffa867',
			1, '#ffbb88'
		]
  }
};

export const COVID_CONFIG = {
	key: 'covid',
	name: 'Málaga Solidaria',
	collection: 'covid',
	logo: '/assets/img/logo_covid.png',
	favicon: '/assets/img/favicon_covid.png',
	welcome: 'Bienvenido a Málaga Solidaria.',
	helpModal: {
		title: 'Málaga Solidaria - Red de ayudas COVID-19',
	  subtitle: '¿Qué iniciativas solidarias hay en Málaga en tiempos de COVID-19? ¿Organizas alguna de ellas? ¿Tienes alguna necesidad?',
	  description: [
	  	'El objetivo de esta plataforma es mostrar qué iniciativas solidarias podemos encontrar en la ciudad de Málaga en la situación actual que vivimos, para darlas a conocer a los ciudadanos y así crear una red de ayudas en tiempos de COVID-19.',
	  	'Si eres un colectivo o una persona individual que está llevando a cabo alguna acción solidaria, puedes registrar tu iniciativa en la plataforma, introduciendo tu contacto para que el resto de ciudadanos pueda conocerte.',
	  	'Si tienes alguna necesidad puedes buscar por temáticas las diferentes acciones solidarias que se están llevando a cabo.'
	  ],
	  image: '/assets/img/covid.gif',
	  type: 'help',
	  id: '',
	  options: '',
	  textBeforeIcons: 'Málaga Solidaria se ha desarrollado en el marco de la investigación del proyecto PIC Málaga (Plataforma de Iniciativas Ciudadanas de Málaga).'
	},
	filters:  ['Aportación económica', 'Deporte desde casa', 'Donación de alimentos', 'Donación de material de protección', 'Farmacias (reparto a domicilio)', 'Hago mascarillas', 'Peluquería a domicilio (1ª necesidad)', 'Pequeño comercio local (reparto a domicilio)', 'Recados', 'Te llamo por teléfono', 'Otros'],
	purpose: [
		{ value: 'Aportación económica', label: 'Aportación económica' },
		{ value: 'Deporte desde casa', label: 'Deporte desde casa' },
		{ value: 'Donación de alimentos', label: 'Donación de alimentos' },
		{ value: 'Donación de material de protección', label: 'Donación de material de protección' },
		{ value: 'Farmacias (reparto a domicilio)', label: 'Farmacias (reparto a domicilio)' },
		{ value: 'Hago mascarillas', label: 'Hago mascarillas' },
		{ value: 'Peluquería a domicilio (1ª necesidad)', label: 'Peluquería a domicilio (1ª necesidad)' },
		{ value: 'Pequeño comercio local (reparto a domicilio)', label: 'Pequeño comercio local (reparto a domicilio)' },
		{ value: 'Recados', label: 'Recados' },
		{ value: 'Te llamo por teléfono', label: 'Te llamo por teléfono' },
		{ value: 'Otros', label: 'Otros' }
	],
	area: null,
  relatedInitiatives: false,
  downloadCSV: false,
  searchLabel: 'Buscar por iniciativa',
  formNameLabel: 'Nombre de la iniciativa - Organizador',
  styles: {
  	navbar: '#E73778',
  	navbarUnderline: 'linear-gradient(to top, #E73778 2px, rgba(0, 174, 199, 0) 2px), linear-gradient(to top, #fdb0cc 2px, rgba(210, 210, 210, 0) 1px)',
  	button: '#9CCFD4',
  	buttonDarker: '#73b8bf',
  	buttonUnderline: 'linear-gradient(to top, #73b8bf 2px, rgba(0, 174, 199, 0) 2px), linear-gradient(to top, #b8e4e8 2px, rgba(210, 210, 210, 0) 1px)',
  	circle: '#2E3146',
  	lineGradient: '#2E3146'
  }
};



